import Vue from 'vue'
import axios from 'axios'
import * as types from '../../types'
import swear from '../../utils/swear'
import laroute from '../../../vendor/laroute'

const state = {}

const getters = {
    [types.users.modules.charges.getters.items]: state => sid => state[sid]
}

const actions = {
    [types.users.modules.charges.actions.reset] ({ commit }) {
        commit(types.users.modules.charges.mutations.reset)
    },
    [types.users.modules.charges.actions.forget] ({ commit }, { sid }) {
        commit(types.users.modules.charges.mutations.forgot, sid)
    },
    [types.users.modules.charges.actions.get] ({ commit }, { sid, params }) {
        return swear(() => {
            return axios
                .get(laroute.route('api.users.charges.index', params))
                .then(({ data: items }) => {
                    commit(types.users.modules.charges.mutations.got, { sid, items })
                })
        }, sid)
    }
}

const mutations = {
    [types.users.modules.charges.mutations.reset] (state) {
        state = {}
    },
    [types.users.modules.charges.mutations.forgot] (state, sid) {
        Vue.delete(state, sid)
    },
    [types.users.modules.charges.mutations.got] (state, payload) {
        Vue.set(state, payload.sid, payload.items)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
